import React, { useEffect, useState } from 'react';
import { Container, Alert, Spinner, Modal, Button, Card, ListGroup } from 'react-bootstrap';
import { shopifyAPI } from '../services/api';

const ShopifyRedirect = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showInstructions, setShowInstructions] = useState(true);
  
  // Show instructions modal immediately when component mounts
  useEffect(() => {
    setShowInstructions(true);
  }, []);
  
  const handleRedirectToShopify = () => {
    // Close the modal
    setShowInstructions(false);
    
    // Redirect to Shopify store
    window.location.href = 'https://littlelambsfundraising.myshopify.com';
  };
  
  return (
    <Container className="auth-container text-center">
      <h2 className="mb-4">Little Lambs Fundraising</h2>
      
      {error ? (
        <div>
          <Alert variant="danger">{error}</Alert>
          <Button 
            variant="primary" 
            onClick={() => window.location.href = '/'}
            className="mt-3"
          >
            Back to Login
          </Button>
        </div>
      ) : (
        <div>
          <Alert variant="info">
            <h4>Ready to Shop!</h4>
            <p>
              Click the button below to continue to the Little Lambs Fundraising store.
            </p>
            <div className="mt-3">
              <Button 
                variant="primary"
                size="lg"
                onClick={handleRedirectToShopify}
              >
                Continue to Shop
              </Button>
            </div>
          </Alert>
        </div>
      )}
      
      {/* Instructions Modal */}
      <Modal 
        show={showInstructions} 
        onHide={() => {
          setShowInstructions(false);
          // Redirect to the main login page
          window.location.href = '/';
        }}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Important Shopping Instructions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="warning" className="mb-4">
            <h5>Please Read Carefully</h5>
            <p>
              To ensure your purchases are properly credited to your fundraiser, you must enter your 
              Group Code and Salesperson Name during checkout.
            </p>
          </Alert>
          
          <Card className="mb-4">
            <Card.Header as="h5">How to Enter Your Information</Card.Header>
            <Card.Body>
              <ListGroup variant="flush" className="mb-3">
                <ListGroup.Item>
                  <strong>1.</strong> Add items to your cart
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>2.</strong> On the cart page, you will see fields to enter:
                  <ul className="mt-2">
                    <li><strong>Group Code</strong> - Enter your fundraising group code</li>
                    <li><strong>Salesperson</strong> - Enter your name</li>
                    <li><strong>Non-Fundraiser</strong> - Check this box if this is not for a fundraiser</li>
                  </ul>
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>3.</strong> Fill in these fields before proceeding to checkout
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>4.</strong> Complete your purchase normally
                </ListGroup.Item>
              </ListGroup>
              
              <Alert variant="danger">
                <strong>Important:</strong> If you do not enter your Group Code and Salesperson name, 
                your purchase will not be credited to your fundraiser.
              </Alert>
            </Card.Body>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowInstructions(false);
            // Redirect to the main login page
            window.location.href = '/';
          }}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleRedirectToShopify}>
            I Understand - Continue to Shop
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ShopifyRedirect;
